<div class="login-container">
  <div class="login-card">

    <img src="assets/img/gma_tipografia.png" alt="GMA" class="login-logo" />
    <p class="login-subtitle">Esqueci minha senha</p>

    @if (!solicitacaoEnviada) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="container-form">
        <div class="field">
          <p-floatlabel variant="on">
            <input pInputText id="login" formControlName="login" [class.ng-invalid]="isInvalid('login')"
              [class.ng-dirty]="isInvalid('login')" />
              <label for="login">Login</label>
            </p-floatlabel>
            @if (isInvalid('login')) {
              <small class="field-error">Login obrigatório</small>
            }
          </div>
          <div>
            <p-button type="submit" label="Solicitar troca de senha" styleClass="w-full" [loading]="loading" />
          </div>
        </form>
        <div class="register-request">
          <a [routerLink]="['/login']" class="register-link">Voltar ao login</a>
        </div>
      } @else {
        <div class="aprovacao-msg">
          <i class="pi pi-check-circle aprovacao-icon"></i>
          <p>Solicitação enviada com sucesso!</p>
          <p>Um administrador precisa liberar a troca de senha. Aguarde ele informar a nova senha.</p>
        </div>
        <div class="register-request">
          <a [routerLink]="['/login']" class="register-link">Voltar ao login</a>
        </div>
      }


    </div>
  </div>
